import * as React from "react";
import { connect } from "react-redux";

import { Header, Grid, Button, Loader } from "semantic-ui-react";
import axios from "axios";

import {
    QuestionConfig, questionnaireTypes, MasterQuestionConfig, CustomQuestionConfig, ConfigurableQuestionnaireKey
} from "@teamprevent/common/questionnaires/questionnaireConfig/models";
import { TermsAndConditionsOfUseConfig } from "@teamprevent/common/termsAndConditions/model";

import { ThunkDispatch } from "redux-thunk";

import { Action } from "redux";

import { ApplicationState } from "../../applicationState";
import { QuestionnaireConfigApi } from "../QuestionnaireConfigApi";

import { loadQuestionnaireConfig } from "../actions";

import { AdditionalQuestionsDetails } from "./AdditionalQuestionsDetails";
import { QuestionDetails } from "./QuestionDetails";

import { Link } from "redux-little-router";

interface StateProps {
    questionnaireName: string;
    masterQuestions: MasterQuestionConfig[];
    customQuestions: QuestionConfig[];
    additionalQuestions: CustomQuestionConfig[];
    path: string;
    questionnaireType: string;
    customerId: string;
    preventAdditionalQuestions?: boolean;
}

type Props = StateProps & DispatchProps;

interface State {
    loadingTermsAndConditionsOfUseDefaultText: boolean;
    termsAndConditionsOfUseDefaultText: string;
}

interface DispatchProps {
    loadQuestionnaireConfig: (customerId: string, questionnaireType: string) => void;
}

class QuestionnaireDetailsUnconnected extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            loadingTermsAndConditionsOfUseDefaultText: true,
            termsAndConditionsOfUseDefaultText: null
        };
    }

    public componentDidMount() {
        this.props.loadQuestionnaireConfig(this.props.customerId, this.props.questionnaireType);

        if (this.props.questionnaireType === TermsAndConditionsOfUseConfig) {
            const questionnaireConfigApi = new QuestionnaireConfigApi(axios);
            questionnaireConfigApi.getTermsAndConditionsOfUseDefaultText()
                .then(configText =>
                    this.setState({ loadingTermsAndConditionsOfUseDefaultText: false, termsAndConditionsOfUseDefaultText: configText.questionText })
                );
        } else {
            this.setState({ loadingTermsAndConditionsOfUseDefaultText: false });
        }
    }

    public render() {
        return (
            <Grid container className="nomargintop">
                <Grid.Row>
                    <Grid.Column>
                        <Header as="h1" content={`${this.props.questionnaireName} Customisation`} />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Loader active={!this.props.customQuestions || this.state.loadingTermsAndConditionsOfUseDefaultText} />
                    {this.props.customQuestions && !this.state.loadingTermsAndConditionsOfUseDefaultText && this.props.masterQuestions.map((question, index) =>
                        (<QuestionDetails
                            masterQuestion={question}
                            customQuestion={this.props.customQuestions.find(q => q.id === question.id)}
                            key={index}
                            questionnaireType={this.props.questionnaireType}
                            customQuestionText={this.state.termsAndConditionsOfUseDefaultText}
                        />)
                    )}
                </Grid.Row>
                {this.props.additionalQuestions && this.props.additionalQuestions.length ?
                    <>
                        <Grid.Row>
                            <Grid.Column>
                                <Header as="h2" content="Further questions" />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <AdditionalQuestionsDetails
                                customerId={this.props.customerId}
                                questionnaireType={this.props.questionnaireType}
                                questions={this.props.additionalQuestions}
                            />
                        </Grid.Row>
                    </>
                    : null
                }
                <Grid.Row>
                    <Grid.Column>
                        {!this.props.preventAdditionalQuestions &&
                            <Button icon="plus" content="Add additional question" floated="right" as={Link} href={`${this.props.path}/create`} />
                        }
                        <Button icon="pencil" content="Edit" floated="right" as={Link} href={`${this.props.path}/edit`} />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }
}

const mapStateToProps = (state: ApplicationState): StateProps => {
    const questionnaireType = state.router.params.questionnaireType as ConfigurableQuestionnaireKey;
    const questionnaireConfig = state.questionnaireConfig[questionnaireType] || { questions: null, additionalQuestions: null };
    return {
        questionnaireName: questionnaireTypes[questionnaireType].displayName,
        masterQuestions: questionnaireTypes[questionnaireType].masterConfig,
        customQuestions: questionnaireConfig.questions,
        additionalQuestions: questionnaireConfig.additionalQuestions,
        path: state.router.pathname,
        questionnaireType: state.router.params.questionnaireType,
        customerId: state.router.params.customerId,
        preventAdditionalQuestions: questionnaireTypes[questionnaireType].preventAdditionalQuestions
    };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<ApplicationState, undefined, Action>): DispatchProps => ({
    loadQuestionnaireConfig: (customerId: string, questionnaireType: string) => {
        dispatch(loadQuestionnaireConfig({ customerId, questionnaireType }));
    }
});

export const QuestionnaireDetails = connect(mapStateToProps, mapDispatchToProps)(QuestionnaireDetailsUnconnected);
